import React from 'react';
import { Box, Typography } from '@mui/material';
import BuyMeCoffeeButton from './BuyMeCoffeeButton';

const BuyMeACroissantBanner = () => {

    return (
        <Box
            sx={{
                borderTop: '1px solid #e9ecef',
                padding: { xs: 2, sm: 3 },
                marginTop: 'auto',
                marginBottom: 0,
                position: 'relative',
                display: 'flex',
                justifyContent: 'center'
            }}
        >
            <Box
                sx={{
                    maxWidth: '700px',
                    width: '100%',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '12px',
                    padding: { xs: 1.5, sm: 2 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #e9ecef'
                }}
            >
                {/* Icon, text, and button */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', sm: 'row' },
                        alignItems: 'center',
                        gap: { xs: 1, sm: 4 },
                        justifyContent: { xs: 'flex-start', sm: 'center' },
                        minHeight: { xs: '80px', sm: 'auto' }
                    }}
                >
                    <img 
                        src="/picky-kitty/croissant.png" 
                        alt="Croissant" 
                        style={{
                            width: '85px',
                            height: '85px'
                        }}
                    />
                    <Box sx={{ 
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'center', sm: 'center' },
                        gap: { xs: 1, sm: 6 },
                        justifyContent: { xs: 'center', sm: 'flex-start' }
                    }}>
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontWeight: 600,
                                    color: '#495057',
                                    fontSize: { xs: '0.95rem', sm: '1rem' },
                                    marginBottom: 0.25
                                }}
                            >
                                Enjoying The Picky Kitty?
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#6c757d',
                                    fontSize: { xs: '0.8rem', sm: '0.85rem' },
                                    lineHeight: 1.4
                                }}
                            >
                                Support the development of this website with a small treat.
                            </Typography>
                        </Box>
                        <Box sx={{
                            '& .buy-me-coffee-img': {
                                width: '215px !important', // 269px * 0.8 = 215px
                                height: '39px !important'  // 49px * 0.8 = 39px
                            }
                        }}>
                            <BuyMeCoffeeButton />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default BuyMeACroissantBanner; 